import ModalComponent from "..";
import { ModalCompProps } from "../../../utils/types";
import { Button } from "../../buttons/button";
import { Icon } from "../../icon/icon";
import { MiniHeader } from "../../typography/miniHeader";

export const ConfirmExitModal = ({
  open,
  handleClose,
  onProceed,
  onCancel,
  loading,
  mode = "create",
}: ModalCompProps & {
  onProceed: () => void;
  onCancel: () => void;
  loading: boolean;
  mode: "edit" | "create";
}) => {
  return (
    <ModalComponent
      open={open}
      handleClose={handleClose}
      className="md:!max-w-[580px]"
      dialogClassName=""
      closeOnOverlayClick
      showHeader={false}
      title={undefined}
      subtitle={undefined}
      showBackIcon={false}
      mobileAnchorBottom
      showCloseIcon={false}
    >
      <div className="flex flex-col gap-4">
        <div className="flex items-start justify-between">
          <Icon
            svg={"info"}
            width={42}
            height={42}
            className="rounded-xl border border-grey-100 p-[11px]"
          />

          <button
            type="button"
            className="w-fit"
            onClick={() => {
              handleClose();
            }}
          >
            <Icon svg={"close-icon"} width={24} height={24} />
          </button>
        </div>

        <div>
          <MiniHeader
            header={"Are you sure you want cancel?"}
            subheader={`Cancelling this means the changes you made will not be saved. If you do not want to lose your changes, please save ${mode === "create" ? "as draft" : "them"}.`}
          />
        </div>

        <div className="col-span-full flex w-full items-center justify-end gap-2">
          <Button
            text={"Yes, cancel"}
            type="button"
            onClick={() => {
              onCancel();
              handleClose();
            }}
            variation="plain-grey"
            className="!max-w-fit"
          />
          <Button
            text={`Save${mode === "create" ? " as draft" : " Changes"}`}
            type="button"
            onClick={onProceed}
            className="!max-w-fit"
            loading={loading}
            disabled={loading}
            variation={"primary"}
          />
        </div>
      </div>
    </ModalComponent>
  );
};
